import { find, get, head } from "lodash";
import { MDBSpinner } from "mdbreact";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import history from "~/history";
import { resetSelectDate } from "~/store/dateAndSpecialist/dateAndSpecialistActions";
import {
  getFilterByStep,
  saveGuaranteeCompany,
  resetFilterByStep
} from "~/store/filter/actions";
import { resetPrice, setPriceOfSvAddOn } from "~/store/payment/paymentAction";
import {
  changeDirection,
  changeServiceType,
  getBookingTree,
  goBackStep,
  resetAddOnService,
  resetFilterCheckData,
  resetListNode,
  selectRadioServiceAddOn,
  selectService,
  setAddonServices,
  setFilterCheckData,
  setGoBack,
  setInsuranceChoice
} from "~/store/totalData/actions";
import { SERVICE } from "~/utils/constants";
import { getPartnerFromUrl } from "~/utils/func";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const Desktop = Loadable({
  loader: () => import("~/components/desktop/pages/Schedules/ChooseService"),
  loading: LoadableLoading
});
class ChooseService extends Component {
  methods = {
    handleGoBack: () => {
      if (this.props.actionBHYT === "SelectedNoBHYT") {
        history.push("/");
      } else {
        this.props.setGoBack();
        this.props.goBackStep("service");
      }
    },
    handleChooseService: service => {
      // this.props.selectService(service);
    }
  };

  componentDidMount() {
    const {
      serviceList,
      isDirectionBack,
      selectService,
      resetListNode,
      getBookingTree,
      resetAddOnService,
      resetPrice,
      actionBHYT,
      isGoBack
    } = this.props;

    if (serviceList.length === 0) {
      const currentPagePartnerId = getPartnerFromUrl(
        this.props.history.location.pathname
      );
      getBookingTree({ partnerId: currentPagePartnerId });
    }
    resetPrice();
    resetAddOnService();
    resetListNode(SERVICE);

    if (!isGoBack || actionBHYT !== "SelectedNoBHYT") {
      if (serviceList.length === 1) {
        const service = head(serviceList);
        const serviceType = get(service, "detail.serviceType");
        const lenghtSvAddon = get(service, "detail.addonServices", 0);
        const popupType = get(service, "detail.popupType", 0);
        if (serviceType !== "BOTH") {
          if (isDirectionBack) {
            this.methods.handleGoBack();
          } else {
            // nếu không có dịch vụ cộng thêm và không có popup cam kết bhyt thì auto chọn đi tiếp
            if (lenghtSvAddon < 1 && popupType === 0) {
              selectService(service);
            }
          }
        }
      }
    } else {
      if (serviceList.length === 1 && actionBHYT !== "SelectedNoBHYT") {
        history.goBack();
      }
    }
  }

  render() {
    const { serviceList } = this.props;

    if (serviceList.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }

    return (
      <React.Fragment>
        <Desktop {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    dateAndSpecialist: {
      selectedSpecialist: { id: selectedSubjectId }
    },
    hospital: { selectedHospital },
    rebooking: { rebookingSelected },
    totalData: {
      actionBHYT,
      isGoBack,
      service: {
        list: serviceList,
        id: serviceId,
        subType: subtypeService,
        serviceType: selectedServiceType
      },
      service: selectedServiceObject,
      listNode,
      isDirectionBack,
      partnerId,
      addonServices,
      treeId,
      filterCheckData
    },
    filter: { checkFilterPopup, guaranteeCompanys }
  } = state;
  const { service } = state.totalData;
  return {
    actionBHYT,
    isGoBack,
    addonServices,
    device: type,
    selectedSubjectId,
    selectedHospital,
    rebookingSelected,
    serviceList,
    serviceId,
    subtypeService,
    listNode,
    service,
    isDirectionBack,
    partnerId,
    selectedServiceType,
    selectedServiceObject,
    treeId,
    checkFilterPopup,
    guaranteeCompanys,
    filterCheckData
  };
};

const ChooseServiceHelmet = withTitle({
  component: ChooseService,
  title: `${hospitalName.value} | Chọn dịch vụ`
});

export default connect(mapStateToProps, {
  resetSelectDate,
  selectService,
  changeDirection,
  changeServiceType,
  resetListNode,
  goBackStep,
  getBookingTree,
  setAddonServices,
  selectRadioServiceAddOn,
  setPriceOfSvAddOn,
  resetAddOnService,
  resetPrice,
  setGoBack: setGoBack,
  getFilterByStep,
  resetFilterByStep,
  saveGuaranteeCompany,
  setInsuranceChoice,
  setFilterCheckData,
  resetFilterCheckData
})(ChooseServiceHelmet);
